/*. v1.6.0

Date: 16/07/2026
✅ Premium Ecommerce Footer
✅ Visa SVG
✅ Mastercard SVG

✅ Apple Pay SVG
✅ Google Pay SVG
✅ Stripe Payment Badge
✅ Glassmorphism UI
✅ Animated Gradient Background
✅ Responsive Layout
✅ Premium Hover Animations
*/

import React from "react";

import { 
  Container, 
  Row, 
  Col 
} from "react-bootstrap";


import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";


export default function Footer(){

return (

<footer className="premium-footer">


<style>{`

.premium-footer{

position:relative;
overflow:hidden;

color:#fff;

background:

radial-gradient(
circle at 10% 10%,
rgba(59,130,246,.25),
transparent 35%
),

radial-gradient(
circle at 90% 90%,
rgba(168,85,247,.25),
transparent 35%
),

#070b18;


border-top:

1px solid rgba(255,255,255,.08);


backdrop-filter:blur(25px);

}



.premium-footer:before{

content:"";

position:absolute;

inset:0;


background:

linear-gradient(
180deg,
transparent,
rgba(0,0,0,.45)
);


pointer-events:none;

}



.premium-footer:after{

content:"";

position:absolute;

width:520px;

height:520px;


right:-160px;

top:-220px;


border-radius:50%;


background:#2563eb;


filter:blur(180px);


opacity:.18;


z-index:0;

}



.footer-container{

position:relative;

z-index:2;


max-width:1400px;


padding:

80px 20px 30px;

}



/* BRAND */


.logo{

font-size:2rem;

font-weight:900;

letter-spacing:-1px;

}



.logo span{

background:

linear-gradient(
90deg,
#60a5fa,
#a78bfa
);


-webkit-background-clip:text;

color:transparent;

}



.tagline{

margin-top:8px;

color:#7dd3fc;


font-size:.82rem;


letter-spacing:3px;


text-transform:uppercase;

}



.brand-description{

margin-top:18px;


max-width:340px;


line-height:1.8;


color:

rgba(255,255,255,.65);

}



/* SOCIAL */


.social{

display:flex;

gap:14px;

margin-top:28px;

}



.social a{

width:46px;

height:46px;


border-radius:16px;


display:flex;

align-items:center;

justify-content:center;


color:white;


text-decoration:none;


background:

rgba(255,255,255,.08);


border:

1px solid rgba(255,255,255,.1);


transition:.35s;


box-shadow:

0 10px 30px rgba(0,0,0,.25);

}



.social a:hover{

transform:

translateY(-6px)
scale(1.08)
rotate(-5deg);


background:

linear-gradient(
135deg,
#2563eb,
#9333ea
);

}



/* PAYMENT */


.payments{

display:flex;

align-items:center;


gap:12px;


flex-wrap:wrap;


margin-top:35px;

}



.payment{

width:78px;

height:45px;


background:

rgba(255,255,255,.96);


border-radius:14px;


display:flex;

align-items:center;

justify-content:center;


padding:8px;


transition:.35s;


box-shadow:

0 8px 25px rgba(0,0,0,.25);

}



.payment:hover{

transform:

translateY(-6px)
scale(1.05);


box-shadow:

0 15px 35px rgba(0,0,0,.35);

}



.payment-logo{

max-width:65px;

max-height:28px;


object-fit:contain;

}



/* STRIPE */


.payment-title{

margin-top:25px;


display:flex;


align-items:center;


gap:12px;


color:

rgba(255,255,255,.75);


font-size:14px;

}



.stripe-logo{

height:30px;


background:white;


padding:5px 12px;


border-radius:10px;


transition:.3s;

}



.stripe-logo:hover{

transform:

scale(1.1);

}



/* FOOTER LINKS */


.footer-heading{

font-size:12px;


font-weight:800;


letter-spacing:2px;


text-transform:uppercase;


margin-bottom:20px;

}



.footer-link{

display:block;


color:

rgba(255,255,255,.65);


text-decoration:none;


margin-bottom:13px;


position:relative;


transition:.3s;

}



.footer-link:hover{

padding-left:10px;


color:#60a5fa;

}



.footer-link:before{

content:"";


position:absolute;


left:-10px;


top:50%;


width:0;


height:2px;


background:#60a5fa;


transition:.3s;

}



.footer-link:hover:before{

width:8px;

}


/* BOTTOM */


.divider{

height:1px;


background:

rgba(255,255,255,.08);


margin:

45px 0 20px;

}



.bottom{

display:flex;


justify-content:space-between;


gap:20px;


flex-wrap:wrap;


color:

rgba(255,255,255,.55);


font-size:14px;

}



.bottom-links{

display:flex;


gap:22px;


flex-wrap:wrap;

}



.bottom-links a{

color:inherit;

text-decoration:none;

}



.bottom-links a:hover{

color:white;

}



/* MOBILE */


@media(max-width:768px){


.footer-container{

padding:

55px 18px 25px;

}


.payments{

justify-content:center;

}


.payment-title{

flex-direction:column;

justify-content:center;

text-align:center;

}


.bottom{

flex-direction:column;

text-align:center;

}


.bottom-links{

justify-content:center;

}


}


`}</style>



<Container className="footer-container">


<Row className="g-5">


<Col lg={4}>


<div className="logo">

🛒 MyIdea<span>Shop</span>

</div>



<div className="tagline">

Startup Ecommerce Platform

</div>



<p className="brand-description">

Discover premium products with a fast,
secure and modern shopping experience
inspired by the world's best ecommerce brands.

</p>



<div className="social">


<a href="#">
<FaFacebookF/>
</a>


<a href="#">
<FaTwitter/>
</a>


<a href="#">
<FaInstagram/>
</a>


<a href="#">
<FaYoutube/>
</a>


</div>



{/* PAYMENT METHODS */}

<div className="payments">


  <div className="payment">
    <img
      src="/images/payments/visa.svg"
      alt="Visa"
      className="payment-logo"
    />
  </div>



  <div className="payment">
    <img
      src="/images/payments/Mastercard.svg"
      alt="Mastercard"
      className="payment-logo"
    />
  </div>



 

  <div className="payment">
    <img
      src="/images/payments/apple-pay.svg"
      alt="Apple Pay"
      className="payment-logo"
    />
  </div>



  <div className="payment">
    <img
      src="/images/payments/google-Pay.svg"
      alt="Google Pay"
      className="payment-logo"
    />
  </div>


</div>



{/* STRIPE TRUST BADGE */}


<div className="payment-title">


<span>
🔒 Secure payments powered by
</span>


<img

src="/images/payments/stripe.svg"

alt="Stripe"

className="stripe-logo"

/>


</div>



</Col>





{/* SHOP */}

<Col lg={2} md={6}>


<div className="footer-heading">

Shop

</div>



<a className="footer-link" href="/shop">

All Products

</a>


<a className="footer-link" href="/categories">

Categories

</a>


<a className="footer-link" href="/deals">

Best Sellers

</a>


<a className="footer-link" href="/new-arrivals">

New Arrivals

</a>


</Col>





{/* COMPANY */}


<Col lg={2} md={6}>


<div className="footer-heading">

Company

</div>



<a className="footer-link" href="/about">

About Us

</a>



<a className="footer-link" href="/careers">

Careers

</a>



<a className="footer-link" href="/blog">

Blog

</a>



<a className="footer-link" href="/contact">

Contact

</a>



</Col>





{/* CUSTOMER CARE */}


<Col lg={2} md={6}>


<div className="footer-heading">

Customer Care

</div>



<a className="footer-link" href="/track-order">

Track Order

</a>



<a className="footer-link" href="/shipping">

Shipping

</a>



<a className="footer-link" href="/returns">

Returns

</a>



<a className="footer-link" href="/faq">

FAQ

</a>



</Col>





{/* LEGAL */}


<Col lg={2} md={6}>


<div className="footer-heading">

Legal

</div>



<a className="footer-link" href="/privacy">

Privacy

</a>



<a className="footer-link" href="/terms">

Terms

</a>



<a className="footer-link" href="/cookies">

Cookies

</a>



<a className="footer-link" href="/refund-policy">

Refund Policy

</a>



</Col>



</Row>





<div className="divider"></div>





<div className="bottom">



<div>

© {new Date().getFullYear()} MyIdeaShop.
All rights reserved.

</div>





<div className="bottom-links">


<a href="/privacy">

Privacy

</a>



<a href="/terms">

Terms

</a>



<a href="/cookies">

Cookies

</a>



<a href="/contact">

Support

</a>



</div>



</div>



</Container>



</footer>

);

}